import SchemaHandler from '@exp/exp-utils/schema/schemaHandler';
import { getCustomerId, getDelegateCustomerId, getEmployeeId, isDelegated } from '@exp/exp-utils/helper/auth';
import VisitHelperTcc from '../../../helpers/visitHelperTcc';
import page from '@tcc/shared/src/interfaces/v1/eventPageProperties';
import { merge } from '@exp/exp-utils/helper/object';
import { error } from '@exp/exp-utils/helper/logger';
import { getISODate } from '@exp/exp-utils/helper/date';
import { sendEventBus } from '@tcc/shared/src/integrations/eventService/eventSend';

const SCC_API_KEY = '7fa38be50ea6578399576329ddd80549';
class BaseEventHandler extends SchemaHandler {

  process() {
    super.process({
      ALL: () => { this._handleEventBus(); }
    });
  }

  _handleEventBus() {
    const events = this._getEvents();
    for (let i = 0; i < events.length; i++) {
      events[i].data = merge({ eventCreationTimestamp: getISODate() }, events[i].data);
    }

    const businessContext = this._getBusinessContext() || null;
    const payload = {
      schemaId: this.data.ALL.schemaId,
      data: [{
        events,
        global: this._getGlobalContext()
      }]
    };
    if (businessContext) {
      payload.data.businessContext = businessContext;
    }
    sendEventBus(payload, this._getApiKey());
  }

  // Abstract method (Required)
  _getEvents() {
    if (process.env.NODE_ENV !== 'production') {
      error('Abstract method {_getEvents} is not implemented');
    }
  }

  // Override method (Optional)
  _getBusinessContext() {}

  // Override method (Optional)
  _getApiKey() {
    return SCC_API_KEY;
  }

  _getGlobalContext() {
    const visitHelper = new VisitHelperTcc();
    const visitInfo = visitHelper.getVisitInfo();
    const delegated = isDelegated();
    return {
      traceId: page.get('trace_id'),
      context: {
        visitorId: visitInfo.visitorGuid,
        sessionId: visitInfo.visitGuid,
        customerId: getCustomerId(),
        // isDelegated: delegated, // not accepted by server validations
        parent: delegated ? {
          customerId: getDelegateCustomerId(),
          agentId: getEmployeeId()
        } : undefined
      }
    };
  }
}

export default BaseEventHandler;
